import { inject, Injectable } from '@angular/core';
import { LoyaltyQrResponse } from '@user/const';
import { LoyaltyQrFacade } from '@user/data-access';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoyaltyQrService {
  private readonly loyaltyQrFacade = inject(LoyaltyQrFacade);

  getLoyaltyQr(): Observable<LoyaltyQrResponse> {
    return this.loyaltyQrFacade.getLoyaltyQr();
  }

  loadLoyaltyQr(): void {
    return this.loyaltyQrFacade.loadLoyaltyQr();
  }
}
